import React, { useCallback, useEffect, useState } from 'react';
import WellbeingCheckin from './WellbeingCheckin';

// FHO-5 for a single-coach pilot: offered on the welcome screen at baseline,
// then at most once every 7 days after the last reading. It never blocks the coach; "Later" hides it until the next visit.
const LABEL = { baseline: 'Before you start', weekly: 'Weekly check-in' };

const PilotCheckin = ({ context, palette }) => {
  const [stage, setStage] = useState(null);
  const [open, setOpen] = useState(false);
  const [done, setDone] = useState(false);
  const token = typeof localStorage !== 'undefined' ? localStorage.getItem('token') : null;
  const laterKey = 'fho5_later_' + context;

  const refresh = useCallback(() => {
    if (!token || !context) return;
    fetch('/api/v1/journey/assessment/pilot-status?context=' + encodeURIComponent(context),
      { headers: { Authorization: 'Bearer ' + token } })
      .then((r) => (r.ok ? r.json() : null))
      .then((d) => { setStage(d && d.due ? d.stage : null); })
      .catch(() => {});
  }, [context, token]);

  useEffect(() => {
    try { if (sessionStorage.getItem(laterKey)) return; } catch (e) { /* storage blocked */ }
    refresh();
  }, [refresh, laterKey]);

  const later = () => {
    try { sessionStorage.setItem(laterKey, '1'); } catch (e) { /* storage blocked */ }
    setStage(null);
  };

  const box = { maxWidth: '720px', margin: '18px auto 0', padding: '16px 20px', borderRadius: '14px',
    border: `1px solid ${palette.border}`, background: 'rgba(0,0,0,0.25)', textAlign: 'center' };

  if (done) {
    return (<div style={box}><div style={{ color: palette.textPrimary, fontSize: '16px' }}>Thank you. Your check-in is saved.</div></div>);
  }
  if (!stage) return null;

  return (
    <div style={box}>
      <div style={{ color: palette.textPrimary, fontSize: '18px', fontWeight: 700 }}>{LABEL[stage] || 'Check-in'}</div>
      <div style={{ color: palette.textSecondary, fontSize: '16px', lineHeight: 1.5, margin: '6px 0 12px' }}>
        A one-minute check-in: five quick ratings of where you are today. It is not a test, and you can do it later.
      </div>
      <button type="button" onClick={() => setOpen(true)}
        style={{ padding: '10px 22px', borderRadius: '10px', border: 'none', background: palette.primary, color: (palette.onPrimary || '#1f1b18'), fontSize: '16px', fontWeight: 700, cursor: 'pointer', fontFamily: 'inherit', marginRight: '10px' }}>
        Take it now
      </button>
      <button type="button" onClick={later}
        style={{ padding: '10px 22px', borderRadius: '10px', border: `1px solid ${palette.border}`, background: 'transparent', color: palette.textPrimary, fontSize: '16px', cursor: 'pointer', fontFamily: 'inherit' }}>
        Later
      </button>
      <WellbeingCheckin
        isOpen={open}
        onClose={() => { setOpen(false); refresh(); }}
        onComplete={() => { setDone(true); try { window.dispatchEvent(new Event('fho5-saved')); } catch (e) { /* older browser */ } }}
        authToken={token}
        context={context}
        palette={palette}
      />
    </div>
  );
};

export default PilotCheckin;
